import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const AppContext = /*#__PURE__*/createContext(undefined);
export const AppContextProvider = ({
  children,
  isAdminPreview,
  isPublic
}) => {
  const appContext = isAdminPreview ? 'admin-preview' : isPublic ? 'public' : 'app';
  return /*#__PURE__*/_jsx(AppContext.Provider, {
    value: appContext,
    children: children
  });
};
export const useAppContext = () => {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error('useAppContext must be used within an AppContextProvider');
  }

  return context;
};